import type { ProfitabilitySummaryResponse } from '../models/Profitability';

export function computeTotalCosts(totals: ProfitabilitySummaryResponse['totals']): number {
  const taxes = totals.recognized_taxes ?? 0;
  return totals.recognized_cogs + totals.recognized_logistics + totals.ad_spend + taxes;
}

export interface ProfitabilityCostSegment {
  id: 'ad_spend' | 'cogs' | 'shipping' | 'taxes';
  value: number;
  color: string;
}

export function getProfitabilityCostSegments(
  totals: ProfitabilitySummaryResponse['totals'],
): ProfitabilityCostSegment[] {
  return [
    { id: 'ad_spend', value: totals.ad_spend, color: '#64748b' },
    { id: 'cogs', value: totals.recognized_cogs, color: '#f59e0b' },
    { id: 'shipping', value: totals.recognized_logistics, color: '#f97316' },
    { id: 'taxes', value: totals.recognized_taxes ?? 0, color: '#6366f1' },
  ];
}
